export default __webpack_public_path__ + "static/media/close_active.ed7a8684.svg";